<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import wexhubIconMark from '../assets/wexhub_icon_mark.svg?url';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <img
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    :src="wexhubIconMark"
  />
</template>
